import { arrayOf, bool, number, shape, string } from 'prop-types';
import React, { Fragment } from 'react';
import LazyLoad from 'components/LazyLoad';
import Picture from 'components/Picture';

// Start loading images before they are in view. Note, this should be a LOW
// value. Performance is more important than preventing placeholders from
// being visible.
export const LAZY_LOAD_OFFSET = 50; // px

function TeaserImage(props) {
  const {
    sourceSets,
    fallbackDims,
    placeholders,
    url,
    hasLazyPicture,
    credit
  } = props;

  const originalImage = (
    <Picture
      className="Teaser__picture--original"
      url={url}
      sourceSets={sourceSets}
      fallbackDims={fallbackDims}
      imgRenderOps={{ quality: 'auto:low' }}
    />
  );

  return (
    <Fragment>
      {hasLazyPicture ? (
        <LazyLoad offset={LAZY_LOAD_OFFSET} once>
          {originalImage}
        </LazyLoad>
      ) : (
        originalImage
      )}
      {credit && <div className="Teaser__credit">{credit}</div>}
      {placeholders.map(({ media, ratio }) => (
        <div key={media} className="Teaser__picture--placeholder">
          <style jsx>{`
            div {
              display: none;
            }
            @media ${media || '(min-width: 0px)'} {
              div {
                display: block;
                height: 0;
                padding-top: ${100 / ratio}%;
              }
            }
          `}</style>
        </div>
      ))}
    </Fragment>
  );
}

TeaserImage.defaultProps = {
  placeholders: [],
  caption: undefined,
  credit: undefined
};

TeaserImage.propTypes = {
  sourceSets: arrayOf(shape({})).isRequired,
  fallbackDims: shape({}).isRequired,
  placeholders: arrayOf(
    shape({
      media: string,
      ratio: number
    })
  ),
  url: string.isRequired,
  hasLazyPicture: bool.isRequired,
  caption: string,
  credit: string
};

export default TeaserImage;
